export default function HeroSection() {
  const handleNav = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      const top = el.getBoundingClientRect().top + window.pageYOffset - 72;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  const stats = [
    { value: '10万+', label: '高清影片资源' },
    { value: '99.9%', label: '播放成功率' },
    { value: '300+', label: '每日更新数量' },
  ];

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
      style={{
        background: 'linear-gradient(135deg, oklch(0.16 0.04 25) 0%, oklch(0.24 0.08 25) 40%, oklch(0.30 0.05 85) 100%)',
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-transparent to-background-50/60 pointer-events-none"></div>

      <div className="relative w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
            <div className="flex-1 w-full text-center lg:text-left">
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-primary-500/15 border border-primary-500/25 text-primary-400 text-xs font-medium mb-6">
                <i className="ri-flashlight-fill text-sm"></i>
                全网最快 · 高清秒播
              </span>

              <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-5">
                快看影视
                <br className="hidden md:block" />
                <span className="text-primary-400">高清免费电影在线观看平台</span>
              </h1>

              <p className="text-base md:text-lg text-white/60 mb-5 font-heading">
                海量片库，即点即播，不缓冲不卡顿
              </p>

              <p className="text-sm md:text-base text-white/50 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
                快看影视汇聚国内外海量高清电影资源，涵盖动作、喜剧、科幻、悬疑、爱情等全类型影片。
                平台采用智能分发与多线加速技术，确保最新电影免费秒播、流畅高清不卡顿免费看。
                每日持续更新片库，无论经典重温还是新片尝鲜，打开快看影视即可畅享极致观影体验。
              </p>

              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
                {stats.map((stat) => (
                  <div key={stat.label} className="text-center">
                    <div className="text-2xl md:text-3xl font-heading font-bold text-primary-400">
                      {stat.value}
                    </div>
                    <div className="text-xs text-white/40 mt-1">{stat.label}</div>
                  </div>
                ))}
              </div>

              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <a
                  href="#app"
                  onClick={(e) => { e.preventDefault(); handleNav('#app'); }}
                  className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-primary-500 hover:bg-primary-600 text-white font-semibold text-sm transition-all whitespace-nowrap cursor-pointer text-center"
                >
                  <i className="ri-play-circle-line mr-2"></i>
                  开始观影
                </a>
                <a
                  href="#features"
                  onClick={(e) => { e.preventDefault(); handleNav('#features'); }}
                  className="w-full sm:w-auto px-8 py-3.5 rounded-lg border border-white/20 hover:border-white/40 text-white/80 hover:text-white text-sm font-medium transition-all whitespace-nowrap cursor-pointer text-center"
                >
                  了解平台优势
                  <i className="ri-arrow-right-line ml-2"></i>
                </a>
              </div>
            </div>

            <div className="flex-1 w-full flex items-center justify-center">
              <div className="relative w-full max-w-md lg:max-w-lg aspect-[4/3] rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20collage%20with%20warm%20theater%20ambiance%2C%20film%20reels%2C%20projector%20light%20beams%2C%20dramatic%20red%20velvet%20curtains%2C%20golden%20spotlights%2C%20classic%20Hollywood%20aesthetic%20with%20modern%20digital%20elements%2C%20rich%20dark%20crimson%20and%20gold%20tones%2C%20luxurious%20cinema%20atmosphere%2C%20abstract%20artistic%20composition%2C%20warm%20glow%20effects%2C%20elegant%20and%20inviting%20visual%20style%2C%20high%20contrast%20dramatic%20lighting&width=1200&height=900&seq=hero-movie-visual&orientation=landscape"
                  alt="快看影视 - 高清电影在线观看平台主视觉"
                  className="w-full h-full object-cover"
                  title="快看影视 - 高清免费电影在线观看"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent rounded-2xl"></div>
                <div className="absolute bottom-4 left-4 right-4 flex items-center gap-2">
                  <span className="px-3 py-1 rounded-full bg-primary-500/80 backdrop-blur-sm text-white text-xs font-medium">
                    热门推荐
                  </span>
                  <span className="px-3 py-1 rounded-full bg-white/15 backdrop-blur-sm text-white/90 text-xs font-medium">
                    每日更新
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}